import React, { useEffect, useState, useContext } from 'react';

import moment from 'moment';

import { makeStyles } from '@mui/styles';
import { ButtonBase, Tooltip } from '@mui/material';


import { EventsContext } from '../EventsContext';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteForever';
import LoaderNew from '../../../common/LoaderNew';

import EventsStyles from '../EventsStyles';
import CommonStyles from '../../../common/CommonStyles';
import ActionConfirmation from '../../../common/ActionConfirmation';
import TrplCheckbox from '../../../common/TrplControls/TrplCheckbox';
import Macros from '../../../common/Macros';

const useStyles = makeStyles({
  ...CommonStyles,
  ...EventsStyles,
});

const EventsByFixedTimeScheduler = (props) => {
  const { updateEvent, deleteEvent } = useContext(EventsContext);
  const [saveLoading, setSaveLoading] = useState(false);
  const [editable, setEditable] = useState(false);
  const [sub, setSub] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const classes = useStyles({
    editable,
    enabled: sub && sub.enabled
  });

  useEffect(() => {
    setSub(props.sub);

    if (props.sub.editable) setEditable(true);
  }, [props]);

  const editSub = (field, value) => {
    const subCopy = { ...sub };

    subCopy[field] = value;

    setSub(subCopy);
  };

  const deleteJelModal = {
    contentText: 'Delete',
    contentBoldText: 'this event?',
    open: showDeleteModal,
  };

  const onSubCronChange = (field, value) => {
    const subTriggerCopy = { ...sub.triggers };

    subTriggerCopy[field] = value;

    setSub({
      ...sub,
      triggers: subTriggerCopy
    });
  };

  const setFunctionPerfValues = (type, value) => {
    setSub({
      ...sub,
      function: value,
    });
  };

  const eventIsUnsaved = sub && !sub.id;

  return (
    <React.Fragment>
      <ActionConfirmation
        modalData={deleteJelModal}
        acceptHandler={() => {
          deleteEvent(null, sub.type, sub.id);
          setShowDeleteModal(false);
          setEditable(false);
        }}
        onClose={() => setShowDeleteModal(false)}
      />

      {sub && (
        <div className={classes.row}>
          <div className={classes.rowContent}>
            <div className={classes.alignStartColumn} style={{ width: '50px'  }}>
              <TrplCheckbox
                className={`${classes.ml10} ${classes.blackCheckbox}`}
                checked={sub.enabled || false}
                onChange={(e) => {
                  if (editable) editSub('enabled', e.target.checked);
                }}
                style={{
                  height: '24px',
                }}
              />
              <div className={classes.nowrap} style={{ width: '20px', marginRight: '10px', marginLeft: '10px' }}>
                {sub.id ? <span className={classes.subId}>id: {sub.id}</span> : null}
              </div>
            </div>

            <div className={`${classes.flex} ${classes.ml10}`} style={{ width: '100%' }}>
              <div className={`${classes.alignStartColumn} ${classes.mr20}`} style={{ minWidth: '356px' }}>
                <div className={`${classes.alignCenter} ${classes.fillAvailable} ${classes.mb10}`}>
                  <span className={classes.columnHeadingGeneral}>Title</span>
                  <input
                    className={`${classes.textFieldInput} ${editable ? '' : classes.noHoverOrFocus}`}
                    value={sub.title || ''}
                    onChange={(e) => {
                      if (editable) editSub('title', e.target.value);
                    }}
                  />
                </div>

                <div className={`${classes.alignCenter} ${classes.fillAvailable} ${classes.mb10}`}>
                  <span className={classes.columnHeadingGeneral}>Cron</span>
                  <input
                    className={`${classes.textFieldInput} ${editable ? '' : classes.noHoverOrFocus}`}
                    value={(sub.triggers && sub.triggers.cron) ? sub.triggers.cron : ''}
                    onChange={(e) => { if (editable) onSubCronChange('cron', e.target.value); }}
                  />
                </div>

                {sub.time ?
                  <div className={`${classes.alignCenter}`}>
                    <span className={`${classes.columnHeadingGeneral} ${classes.mr5}`}>Time</span>
                    <div className={`${classes.nowrap}`}>
                      <span className={`${classes.nowrap} ${classes.subId}`}>{moment(sub.time).format('DD MMM YYYY HH:mm')}</span>
                    </div>
                  </div>
                : null}
              </div>

              <div className={classes.functionCol}>
                <Macros
                  showCode={true}
                  fullWidth={true}
                  editable={editable}
                  oldMacro={props.sub.function || ''}
                  functionVal={sub.function || ''}
                  setFunctionPerfValues={setFunctionPerfValues}
                />
              </div>

              <div className={`${classes.editRowCol}`}>
                {!editable ? (
                  <Tooltip
                    title="Edit"
                    placement="top"
                    classes={{
                      tooltip: classes.muiTooltip,
                    }}
                  >
                    <EditIcon
                      onClick={() => {
                        setEditable(true);
                      }}
                    />
                  </Tooltip>
                ) : null}
              </div>
            </div>
          </div>

          {editable ? (
            <div className={classes.rowButtonsContainer}>
              {!eventIsUnsaved ? (
                <ButtonBase
                  className={`${classes.rowActionBtn} ${classes.btn} ${classes.btnEmpty} ${classes.mr10}`}
                  onClick={() => {
                    setShowDeleteModal(true);
                  }}
                >
                  <span>Delete</span>

                  <DeleteIcon className={classes.deleteRowIcon} />
                </ButtonBase>
              ) : <div />}

              <div className={classes.alignCenter}>
                <ButtonBase
                  className={`${classes.rowActionBtn} ${classes.btn} ${classes.btnEmpty} ${classes.mr10}`}
                  onClick={() => {
                    setEditable(false);
                    setSub(props.sub);

                    // unsaved events shouldn't be in events list after editing
                    if (eventIsUnsaved) {
                      deleteEvent(null, sub.type, sub.draft_id);
                    }
                  }}
                >
                  Cancel
                </ButtonBase>
                <ButtonBase
                  className={`${classes.rowActionBtn} ${classes.btn} ${classes.btnNormal}`}
                  onClick={() => {
                    if (!sub.entityType) sub.entityType = 102;
                    setSaveLoading(true);

                    updateEvent(null, sub.type, sub, (updatedSub) => {
                      setSub(updatedSub);
                      setEditable(false);
                      setSaveLoading(false);
                    });
                  }}
                >
                  {saveLoading ? <LoaderNew /> : 'Save'}
                </ButtonBase>
              </div>
            </div>
          ) : null}
        </div>
      )}
    </React.Fragment>
  );
};

export default EventsByFixedTimeScheduler;
